import React from 'react';
import type { FunctionComponent } from 'react';
import { differenceInDaysHandler, longDateHandler } from '@utils';

interface PausedStatusProps {
	pausedOnUtc: string;
}

export const PausedStatus: FunctionComponent<PausedStatusProps> = ({ pausedOnUtc }) => {
	return (
		<div className="account-status-tooltip">
			<p className="account-status-content-row account-status-content-row--bold">Paused on:</p>
			<p className="account-status-content-row">{longDateHandler(pausedOnUtc)}</p>
			<p className="account-status-content-row">{differenceInDaysHandler(pausedOnUtc)} days ago</p>
		</div>
	);
};
